export function flattenObject(obj, parentKey = '', result = {}, delimiter = '.') {
    if (obj == null || typeof obj !== 'object') return result;

    
    let normalized;
    try {
        normalized = obj && typeof obj.toJS === 'function' ? obj.toJS() : obj;
    } catch (err) {
        console.warn('Failed to convert to plain JS:', err);
        normalized = obj;
    }

    Object.keys(normalized).forEach((key) => {
    
        if (key.startsWith('_') || key.startsWith('__')) return;

        const value = normalized[key];
        const newKey = parentKey ? `${parentKey}${delimiter}${key}` : key;

        if (Array.isArray(value)) {
            value.forEach((item, index) => {
                const arrayKey = `${newKey}${delimiter}${index}`;
                if (item && typeof item === 'object') {
                    flattenObject(item, arrayKey, result, delimiter);
                } else if (item !== null && item !== '' && item !== undefined) {
                    result[arrayKey] = item;
                }
            });
        } else if (value && typeof value === 'object') {
            flattenObject(value, newKey, result, delimiter);
        } else if (value !== null && value !== '' && value !== undefined) {
            result[newKey] = value;
        }
    });

    return result;
}
